import type { SubmitData } from "@superdoc-dev/esign";

// Snake_case version of SubmitData for Django backend
// Only includes fields expected by the API (per applicant.yml SignatureSubmit schema)
export interface SubmitDataSnakeCase {
  timestamp: string;
  audit_trail: SubmitData["auditTrail"];
  document_fields: SubmitData["documentFields"];
  signer_fields: Array<{
    id: string;
    type: string;
    value: unknown;
  }>;
}

// Convert SuperDoc camelCase to Django snake_case.
// Expects signer fields to already be enriched with `type` by ESignDocument.
export function toSnakeCaseSubmitData(data: SubmitData): SubmitDataSnakeCase {
  return {
    timestamp: data.timestamp,
    audit_trail: data.auditTrail,
    document_fields: data.documentFields,
    signer_fields: data.signerFields.map((field) => ({
      id: field.id,
      type: (field as { type?: string }).type ?? "signature",
      value: field.value,
    })),
  };
}
